export enum UserRole {
  ADMIN = 'Admin',
  OPERATOR = 'Operator',
  VIEWER = 'Viewer',
  MOBILE_USER = 'MobileUser',
  UNKNOWN = 'Unknown',
}
